const createFishShape2 = shape => {
  shape.moveTo(3.25824, 13.5998);
  shape.lineTo(0.98824, 20.4164);
  shape.bezierCurveTo(0.526921, 21.8017, 1.66127, 23.2073, 3.09582, 22.9354);
  shape.bezierCurveTo(6.72494, 22.2478, 9.27944, 21.0198, 12.6577, 18.1038);
  shape.bezierCurveTo(13.03, 17.7824, 13.5048, 17.5982, 13.9966, 17.5982);
  shape.lineTo(15.8591, 17.5982);
  shape.bezierCurveTo(16.2116, 17.5982, 16.5586, 17.692, 16.8637, 17.8685);
  shape.bezierCurveTo(19.9676, 19.6641, 22.0912, 20.8204, 25.1204, 21.6286);
  shape.bezierCurveTo(26.291, 21.9409, 26.8788, 23.3025, 26.214, 24.3155);
  shape.bezierCurveTo(25.4674, 25.453, 26.3068, 26.9583, 27.6663, 26.9048);
  shape.bezierCurveTo(44.2801, 26.2508, 52.6992, 23.1507, 61.7513, 12.3774);
  shape.bezierCurveTo(62.4541, 11.5409, 62.3239, 10.2853, 61.4508, 9.62862);
  shape.bezierCurveTo(56.0892, 5.59588, 52.0139, 4.59932, 45.1357, 4.14946);
  shape.bezierCurveTo(44.6026, 4.11459, 44.1074, 3.86732, 43.7329, 3.48641);
  shape.bezierCurveTo(41.5314, 1.24725, 39.3326, 0.529726, 35.8972, 0.187464);
  shape.bezierCurveTo(34.6114, 0.0593643, 33.5885, 1.22141, 33.8162, 2.49335);
  shape.lineTo(33.8829, 2.86644);
  shape.bezierCurveTo(34.0766, 3.94836, 33.3609, 4.98381, 32.2804, 5.18503);
  shape.lineTo(27.2843, 6.11542);
  shape.bezierCurveTo(26.7604, 6.21299, 26.2242, 6.08882, 25.7672, 5.81473);
  shape.bezierCurveTo(24.5505, 5.08505, 23.3758, 4.72876, 21.4367, 4.71012);
  shape.bezierCurveTo(20.1716, 4.69796, 19.3257, 5.95915, 19.6874, 7.17154);
  shape.bezierCurveTo(19.9511, 8.05545, 19.5745, 9.00489, 18.7767, 9.46777);
  shape.lineTo(16.8627, 10.5782);
  shape.bezierCurveTo(16.5578, 10.755, 16.2116, 10.8482, 15.8591, 10.8482);
  shape.lineTo(14.9917, 10.8482);
  shape.bezierCurveTo(14.4218, 10.8482, 13.8816, 10.6003, 13.4859, 10.1901);
  shape.bezierCurveTo(10.6629, 7.26316, 8.05795, 6.22985, 4.28651, 5.42258);
  shape.bezierCurveTo(2.84309, 5.11361, 1.61462, 6.47377, 2.01365, 7.89493);
  shape.lineTo(3.28624, 12.4273);
  shape.bezierCurveTo(3.3943, 12.8122, 3.38455, 13.2206, 3.25824, 13.5998);

  return shape;
};

export default createFishShape2;
